(function () {
  const sectionEl = document.querySelector('.lo-sa')
  if (!sectionEl) return

  const cards = [].slice.call(sectionEl.querySelectorAll('.lo-sa-card[data-col]'))
  if (!cards.length || !window.fetch || !window.IntersectionObserver) return

  const still = window.matchMedia('(prefers-reduced-motion: reduce)')
  const pace = Number(sectionEl.dataset.pace || 6) * 1000
  const grid = sectionEl.querySelector('.lo-sa-cards')
  let timers = []
  let states = []
  let inView = false
  let requested = false
  let paused = false

  function stop () {
    timers.forEach(function (timer) {
      clearInterval(timer)
    })
    timers = []
  }

  function paint (state, item) {
    state.links.forEach(function (a) {
      a.setAttribute('href', item.u)
    })
    state.name.textContent = item.n
    state.price.textContent = item.p
    state.price.classList.toggle('is-sale', !!item.c)
    if (item.c) {
      const before = document.createElement('s')
      before.className = 'lo-sa-was'
      before.textContent = item.c
      state.price.appendChild(before)
    }
  }

  function prepare (card) {
    const frame = card.querySelector('.lo-sa-img-wrap')
    const base = card.querySelector('.lo-sa-img-a')
    const links = [].slice.call(card.querySelectorAll('.lo-sa-shot, .lo-sa-meta'))
    const price = card.querySelector('.lo-sa-price')
    const name = card.querySelector('.lo-sa-name')
    if (!frame || !base || !links.length || !price || !name) return Promise.resolve(null)

    const markdown = price.querySelector('.lo-sa-was')
    const initial = {
      i: base.getAttribute('src'),
      u: links[0].getAttribute('href'),
      n: name.textContent.trim(),
      p: price.childNodes[0] ? price.childNodes[0].nodeValue.trim() : '',
      c: markdown ? markdown.textContent.trim() : ''
    }

    return fetch(
      '/collections/' + card.getAttribute('data-col') + '?sort_by=best-selling&view=cards'
    )
      .then(function (response) {
        return response.ok ? response.json() : []
      })
      .then(function (fetched) {
        const seen = {}
        const items = [initial]
        seen[initial.u] = true
        fetched.forEach(function (prod) {
          if (prod.u && prod.i && !seen[prod.u]) {
            seen[prod.u] = true
            items.push(prod)
          }
        })
        if (items.length < 2) return null

        const layer = base.cloneNode(false)
        layer.className = base.className.replace('lo-sa-img-a', 'lo-sa-img-b')
        layer.removeAttribute('loading')
        layer.setAttribute('alt', '')
        frame.appendChild(layer)

        return {
          a: base,
          b: layer,
          links,
          price,
          name,
          items,
          i: 0,
          onTop: false
        }
      })
      .catch(function () {
        return null
      })
  }

  function advance (state) {
    const next = state.items[(state.i + 1) % state.items.length]
    const previous = new Image()
    previous.onload = function () {
      const enter = state.onTop ? state.a : state.b
      const sale = state.onTop ? state.b : state.a
      enter.src = next.i
      enter.style.opacity = '1'
      sale.style.opacity = '0'
      paint(state, next)
      state.onTop = !state.onTop
      state.i = (state.i + 1) % state.items.length
    }
    previous.src = next.i
  }

  function start () {
    stop()
    if (still.matches || document.hidden || paused || !inView || !states.length) return
    timers.push(
      setInterval(function () {
        states.forEach(function (state) {
          advance(state)
        })
      }, pace)
    )
  }

  const watcher = new IntersectionObserver(
    function (entries) {
      inView = entries.some(function (e) {
        return e.isIntersecting
      })
      if (!inView || still.matches) {
        stop()
        return
      }
      if (requested) {
        start()
        return
      }
      requested = true
      Promise.all(cards.map(prepare)).then(function (res) {
        states = res.filter(Boolean)
        start()
      })
    },
    { rootMargin: '300px' }
  )

  function hold () {
    paused = true
    stop()
  }
  function resume (e) {
    if (e && e.relatedTarget && grid.contains(e.relatedTarget)) return
    paused = false
    start()
  }

  function teardown (e) {
    if (e && e.target && !e.target.contains(sectionEl)) return
    stop()
    watcher.disconnect()
    document.removeEventListener('visibilitychange', start)
    document.removeEventListener('shopify:section:unload', teardown)
    still.removeEventListener('change', start)
    grid.removeEventListener('pointerenter', hold)
    grid.removeEventListener('pointerleave', resume)
    grid.removeEventListener('focusin', hold)
    grid.removeEventListener('focusout', resume)
  }

  watcher.observe(sectionEl)
  document.addEventListener('visibilitychange', start)
  document.addEventListener('shopify:section:unload', teardown)
  still.addEventListener('change', start)
  grid.addEventListener('pointerenter', hold)
  grid.addEventListener('pointerleave', resume)
  grid.addEventListener('focusin', hold)
  grid.addEventListener('focusout', resume)
})()
